<template>
  <div id="not-found"><p>Page Not Found</p></div>
</template>

<script>
export default {

}
</script>

<style>
#not-found {
  padding: var(--page-padding);
}

#not-found p {
  font-size: var(--h1-font-size);
}

</style>